import { notificationsActions } from './actions';
import { notificationsMutations } from './mutations';
import { notificationsGetters } from './getters';

const state = {
    notifications: {}
};
const actions = { ...notificationsActions };
const mutations = { ...notificationsMutations };
const getters = { ...notificationsGetters };


// eslint-disable-next-line import/prefer-default-export
export const notificationsStore = {
    state, actions, mutations, getters,
};
